import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.sevenSection;
export default {
  ...textInfo
};
